import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import logo from '../images/polymedia-citrus.png';
import config from '../config.js';

import {fetchDataIfReady, fetchDataIfUndefined} from 'Skelet/src/modules/fetch.action.js';


class ArticleFeedback extends React.Component {

  constructor(props) {
    super(props);

    let embed_interface = false;
    let poll_language = "NL";
    if(typeof URLSearchParams === "function") {
      let params = new URLSearchParams(this.props.location.search);
      let param_embed = params.get('embed');
      let param_lang = params.get('lang');
      if(param_embed === "") {
        embed_interface = true;
      }
      if(param_lang && param_lang.trim() !== "" && param_lang.toLowerCase() === "en") {
        poll_language = "EN";
      }
    }
    document.documentElement.setAttribute('lang', poll_language.toLowerCase());

    this.state = {
      disabled: false,
      embed_interface,
      poll_language,
      shown:false,
      stars:5,
      text:"",
      email:""
    };
  }

  componentWillMount() {
  }

  componentWillReceiveProps(nextProps) {
  }

  render() {
    const poll_language = this.state.poll_language;

    document.title = "Citrus Poll · Feedback Widget · Citrus by Polymedia";

    let header = "Was dit artikel behulpzaam?";
    if(poll_language === "EN") {
      header = "Was this article helpful?";
    }

    import('../poll.css');
    return (
      <div>
        <div style={(!this.state.embed_interface) ? {padding:"1em", background:"#f5f5f5", minHeight:"100vh"} : null}>
          <div className="poll articlefeedback" style={(!this.state.embed_interface) ? {margin:"2em auto", maxWidth:"700px"} : null}>
            <div className="poll-header"><div>{header}</div><div style={(!this.state.embed_interface) ? {display:"none"} : null}><a href="https://citrus.polymedia.nl/" target="_blank" rel="noopener noreferrer"><img src={logo} alt="Citrus by Polymedia" /></a></div><br style={{clear:"both"}}/></div>
            <form>
              <div className="poll-footer">
                {poll_language === "NL" && !this.state.disabled && <button onClick={() => this.confirm(1)} className="selected" style={{border:"0", marginRight:"15px"}}>Ja</button>}
                {poll_language === "EN" && !this.state.disabled && <button onClick={() => this.confirm(1)} className="selected" style={{border:"0", marginRight:"15px"}}>Yes</button>}
                {poll_language === "NL" && !this.state.disabled && <button onClick={() => this.confirm(0)} className="selected" style={{border:"0"}}>Nee</button>}
                {poll_language === "EN" && !this.state.disabled && <button onClick={() => this.confirm(0)} className="selected" style={{border:"0"}}>No</button>}
                {poll_language === "NL" && this.state.disabled && <span>Bedankt voor jouw feedback!</span>}
                {poll_language === "EN" && this.state.disabled && <span>Thank you for your feedback!</span>}
              </div>
            </form>
          </div>
          {!this.state.embed_interface && <div className="logo-footer"><a href="https://citrus.polymedia.nl/" target="_blank" rel="noopener noreferrer"><img src={logo} alt="Citrus by Polymedia" /></a></div>}
        </div>
      </div>
    );
  }


  toggle = () => {
    this.setState({shown:!this.state.shown});
  };

  confirm(yesno) {
    if(!this.state.disabled) {
      let url = (window.location !== window.parent.location) ? document.referrer : document.location.href;
      let ref_id = this.props.match.params.id;
      this.props.fetchDataIfReady(config.api_token, "bin", "POST", config.api_url+"/articlefeedback", JSON.stringify({id:ref_id, yesno, url}), null, true);
      this.setState({disabled:true});
    }
  };

}


function mapStateToProps(state) {
  return {
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    fetchDataIfUndefined,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticleFeedback)



// WEBPACK FOOTER //
// ./src/containers/ArticleFeedback.js